// eslint-disable-next-line no-restricted-imports
import { Box, Chip, Flex, Spinner } from '@applyboard/crystal-ui';

import { CardProps } from '../ServiceCard';
import { ServiceCardsDisplay } from './ServiceCardsDisplay';

type Persona = 'student' | 'rp';

export interface ChipOption {
  label: string;
  value: string;
}

interface ServiceCardsSectionProps {
  chipOptions: ChipOption[];
  selectedChips: string[];
  toggleChip: (chip: string) => void;
  selectedCardsData: CardProps[];
  isLoading?: boolean;
  persona: Persona;
  showUsdNotice?: boolean;
}

export const ServiceCardsSection = ({
  chipOptions,
  selectedChips,
  toggleChip,
  selectedCardsData,
  isLoading,
  persona,
  showUsdNotice = false,
}: ServiceCardsSectionProps) => {
  return (
    <Flex direction="column" gap={4}>
      <Flex justify="center" gap={2} wrap>
        {chipOptions.map(({ label, value }) => (
          <Chip
            key={value}
            selected={selectedChips.includes(value)}
            onClick={() => toggleChip(value)}
            aria-pressed={selectedChips.includes(value)}
            emphasis="plain"
            size="sm"
            width="hug"
          >
            {label}
          </Chip>
        ))}
      </Flex>
      <Box pt={4}>
        {isLoading ? (
          <Flex align="center" justify="center">
            <Spinner size="xl" />
          </Flex>
        ) : (
          <ServiceCardsDisplay
            cardsData={selectedCardsData}
            persona={persona}
            showUsdNotice={showUsdNotice}
          />
        )}
      </Box>
    </Flex>
  );
};
export default ServiceCardsSection;
